import {graphql, useStaticQuery} from "gatsby";

const useSearchPrefix = (): string => {

    const data = useStaticQuery(graphql`
        query {
            wp {
                siteOptions {
                    websiteFunktionen {
                        searchPrefix
                    }
                }
            }
        }
    `)
    return data.wp.siteOptions.websiteFunktionen.searchPrefix + "_";
};

export default useSearchPrefix;
